<template>
  <div class="l-container">
    <div class="lcontainer--inner">
      <div data-personalisation class="c-helpAutomation-component" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import '@justeat/personalised-help'
import ConfigService from '../services/ConfigService'
import featuresConfig from '../utilities/featureManager.features'
import getFeatures from '../utilities/featureManager'


export default {
  name: 'PersonalisedHelp',
  computed: {
    ...mapGetters(['personalisationState'])
  },
  mounted() {
    // NOTE: Component needs to have mounted,
    // for the `config` container to be picked up
    const config = ConfigService.personalisation()

    async function instantiateWithFeatures(configuration) {
      const { snowplowToggle, onewebRollout } = featuresConfig
      const { snowplowFeat = snowplowToggle, oneWebFeat = onewebRollout } = await getFeatures({ snowplowToggle, onewebRollout })
      configuration.analytics.enabled = snowplowFeat.value
      configuration.analytics.isOneWeb = oneWebFeat.value
      configuration.analytics.globalContext = window.$spGlobalContext

      // Instantiate Personalisation Component
      window.jePersonalisedHelp.init(configuration)
    }

    if (
      config.enabled &&
      this.personalisationState.visible &&
      window.jePersonalisedHelp
    ) {
      this.$store.dispatch('personalisationLoading')
      config.customisationResponseCallback = this.customisationResponseCallback
      config.container = document.querySelector('[data-personalisation]')
      config.onUnavailable = this.displayFallbackContent
      instantiateWithFeatures(config)
    }
  },
  methods: {
    // TODO: does not appear to be in use
    forceUpdate() {
      window.jePersonalisedHelp.reload()
    },
    displayFallbackContent(e) {
      this.$store.dispatch('useFallbackForTopLevelActions')
      this.$store.dispatch('personalisationError', e)
    },
    customisationResponseCallback(data) {
      this.$store.dispatch('setCustomisation', data)
    }
  }
}
</script>

<style lang="scss">
@import '@justeat/personalised-help/dist/personalised-help.css';

.consumerHelpApp {
  .c-helpAutomation-component {
    margin: 40px 0;
    padding: 0;

    // Clear above component
    &:before {
      content: ' ';
      display: table;
      clear: both;
    }

    & > .l-container {
      padding: 0;
    }

    .c-order-customisation--login {
      margin-top: 0;
    }
  }
}
</style>
